<div class="d-flex align-items-center justify-content-between w-100 p-4">
    @for(shortcut of shortcuts(); track shortcut.title; let index = $index) {
        <div 
            class="shortcut-btn"
            [animate.enter]="'shortcut-enter'"
            [animate.leave]="'shortcut-leave'"
            [style.--enter-index]="index"
        >
            <p-button
                raised
                severity="info"
                styleClass="p-2 w-100 h-100"
                [disabled]="shortcut.disabled"
                (onClick)="clickShortcut(shortcut, op, $event)"
            >

                <fa-icon
                    [icon]="shortcut.disabled ? faSpinnerThird : shortcut.icon"
                    [class.fa-spin]="shortcut.disabled"
                    class="icon"
                ></fa-icon>
                @if (routingWorkflow !== null 
                    && routingWorkflow() === shortcut.workflow
                ) {
                    <span>Routing...</span>
                } @else {
                    <span>{{ shortcut.title }}</span>
                }
            </p-button>
        </div>
    }
</div>

<p-popover
    #op
    (onShow)="onShortcutShow()"
    (onHide)="onShortcutClose()"
> 
    <ng-template #content>
        @if (popoverShortcut() && !activeAddtionalTemplate()) {
            <div class="popover-options fade-in">
                @for(option of popoverShortcut()?.options ?? []; track option.label) {
                    <p-button
                        fluid
                        [disabled]="$safeNavigationMigration(popoverShortcut()?.disabled)"
                        [dt]="getBtnDt($safeNavigationMigration(popoverShortcut()?.workflow), option.value)"
                        (onClick)="triggerAction(popoverShortcut(), option.value, op)"
                    >
                        {{ option.label }}
                    </p-button>
                }
            </div>
        }
        @else if (activeAddtionalTemplate()) {
            @switch(popoverShortcut()?.additionalTemplate)
            {
                @case('transfer')
                {
                    <ng-container *ngTemplateOutlet="transferAdditionalOptions"></ng-container>
                }
                @case('quarantine')
                {
                    <ng-container *ngTemplateOutlet="quarantineAdditionalOptions"></ng-container>
                }
            }    
        }
    </ng-template>
</p-popover>

<!--#region Transfer Additional Options -->

<ng-template
    #transferAdditionalOptions
>
    <div class="transfer-container fade-in">
        <div class="row">
            <div class="col-md-12">
                <div class="mb-3">
                    <div><b>From:</b></div>
                    <div>{{selectedInventory()?.name}}</div>
                </div>
                <div>
                    <div><b>To:</b></div>
                    @if (transferItemsLoading()) {
                        <p-skeleton height="2.375rem" borderRadius="6px" styleClass="fade-in" />
                    } @else {
                        <p-select
                            class="fade-in"
                            [(ngModel)]="destinationTransferInventoryId"
                            [options]="inventoryTransferSelectItems()"
                            placeholder="Select an Inventory..."
                            optionLabel="text"
                            optionValue="value"
                            [filter]="true"
                            filterBy="text"
                            styleClass="w-100"
                            [panelStyle]="{'--p-select-option-padding': '0px'}"
                        >
                            <ng-template
                                #selectedItem
                                let-item
                            >
                                <ng-container
                                    *ngTemplateOutlet="invTransferSelectedItem; context: {
                                        item: item
                                    }"
                                />
                            </ng-template>
                            <ng-template
                                #item
                                let-item
                            >
                                <ng-container
                                    *ngTemplateOutlet="invTransferSelectItems; context: {
                                        item: item
                                    }"
                                />
                            </ng-template>
                        </p-select>
                    }
                </div>
            </div>
        </div>

        @if (isOutOfCountyTransfer()) {
            <div class="mt-3">
                <label class="for">Why are you requesting an out-of-county transfer?</label>
                <textarea 
                    class="w-100" 
                    rows="5"
                    [(ngModel)]="outOfCountyTransferComment" 
                ></textarea>
            </div>
        }

        <div class="row mt-3 min-popover-width">
            <div class="col-6 pe-1">
                <p-button 
                    label="Cancel"
                    styleClass="w-100"
                    size="large"
                    severity="secondary"
                    (onClick)="op.toggle($event);"
                />
            </div>
            <div class="col-6 pe-1">
                <p-button 
                    [label]="isOutOfCountyTransfer() ? 'Request Transfer' : 'Create Transfer'"
                    [disabled]="transferDisabled()"
                    styleClass="w-100"
                    size="large"
                    severity="success"
                    (onClick)="createTransfer()"
                    [disabled]="transferDisabled()"
                    [pTooltip]="getCreateTransferBtnTooltip()"
                    tooltipPosition="top"
                />
            </div>
        </div>
    </div>
</ng-template>
<ng-template 
    let-item="item"
    #invTransferSelectedItem
>
    <span
        class="w-100 h-100 d-flex justify-content-between rounded p-2"
        [ngClass]="{'alert-warning': $safeNavigationMigration(item?.additionalData?.showTransferWarning)}"
        [pTooltip]="getTransferInvItemTooltip(item)"
        tooltipPosition="bottom"
    >
        <span>{{ item?.text }}</span>
        <span>@if (item?.additionalData?.showTransferWarning) { <i class="pi pi-exclamation-triangle"></i> }</span>
    </span>
</ng-template>

<ng-template
    let-item="item"
    #invTransferSelectItems
>
    <span
        class="w-100 d-flex align-items-center justify-content-between p-1"
        [ngClass]="{'alert-warning': $safeNavigationMigration(item?.additionalData?.showTransferWarning)}"
        [pTooltip]="getTransferInvItemTooltip(item)"
        tooltipPosition="bottom"
        (click)="selectTransferItem(item)"
    >
        <span>{{ item?.text }}</span>
        <span>@if (item?.additionalData?.showTransferWarning) { <i class="pi pi-exclamation-triangle"></i> }</span>
    </span>
</ng-template>

<!--#endregion -->

<!--#region Quarantine Additional Options -->

<ng-template
    #quarantineAdditionalOptions
>
    <div class="quarantine-content fade-in">
        @if (quarantineMode() == QuarantineTypeEnum.Bulk) {
            <div>
                <a
                    class="btn btn-link p-0"
                    (click)="openAddBulkModal()"
                >Don't have a scanner?</a>
            </div>

            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <div class="d-flex mb-1">
                        <pcg-scan-product-standalone
                            #scanner
                            [includeProductInfo]="true"
                            [isFulfillment]="false"
                            (scanSuccess)="processBulkScan($event)"
                            [autofocus]="true"
                            [scanDetection]="true"
                            [inputPlaceholder]="'Scan GS1 Barcode'"
                            [showHelp]="true"
                        ></pcg-scan-product-standalone>
                    </div>
                </div>
            </div>
        } @else if (quarantineMode() == QuarantineTypeEnum.PID) {
            <div>
                <a
                    class="btn btn-link p-0"
                    (click)="openPidManualEntry()"
                >Don't have a scanner?</a>
            </div>
            <div>
                <pcg-scan-pid
                    [doLookup]="false"
                    (rawScanOutput)="processPidScan($event)"
                    (rawManualOutput)="processPidScan($event)"
                />
            </div>
        } @else if (quarantineMode() == QuarantineTypeEnum.LoosePills) {
            @if (isLoadingContainer()) {
                <div class="loose-pills-skeleton">
                    <p-skeleton width="9rem" height="1.5rem" styleClass="mb-3" />
                    <div class="loose-pill-form-skeleton p-2">
                        <div class="d-flex flex-column gap-2">
                            <p-skeleton height="2.375rem" borderRadius="6px" />
                            <p-skeleton height="2.375rem" borderRadius="6px" />
                            <p-skeleton height="2.375rem" borderRadius="6px" />
                        </div>
                        <div class="d-flex flex-column gap-2">
                            <p-skeleton height="2.375rem" borderRadius="6px" />
                            <p-skeleton height="2.375rem" borderRadius="6px" />
                            <p-skeleton height="2.375rem" borderRadius="6px" />
                        </div>
                        <p-skeleton height="8.125rem" borderRadius="6px" />
                    </div>
                </div>
            } @else {
                <div class="fade-in">
                    <p-badge
                        [severity]="isNewContainer() ? 'info' : 'success'"
                        [value]="isNewContainer() ? 'NEW CONTAINER' : `CONTAINER C-${$safeNavigationMigration(loosePillService.container()?.loosePillContainerId)}`"
                    />
                    <pcg-sys-inv-edit-loose-pill
                        (pillAdded)="loosePillAdded()"
                    />
                </div>
            }
        }
    </div>
</ng-template>

<!--#endregion -->